import { cn } from "@/lib/utils";

/**
 * Like2Fit Skeleton — cream→sand shimmer on the brand palette.
 * Drop-in replacement for the default shadcn skeleton.
 */
function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("l2f-skeleton rounded-xl", className)}
      aria-hidden="true"
      {...props}
    />
  );
}

export { Skeleton };
